/**
 * Locale-aware date formatting helpers.
 *
 * Uses `Intl.DateTimeFormat` so month/day names follow the active UI language.
 */

const DEFAULT_LOCALE = 'en';

const toValidDate = (input) => {
  if (!input) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatShortDate = (dateInput, locale = DEFAULT_LOCALE) => {
  const date = toValidDate(dateInput);
  if (!date) return '';

  const options = { month: 'short', day: 'numeric', year: 'numeric' };

  try {
    return new Intl.DateTimeFormat(locale || DEFAULT_LOCALE, options).format(date);
  } catch (e) {
    // In case an invalid/unsupported locale is provided.
    return new Intl.DateTimeFormat(DEFAULT_LOCALE, options).format(date);
  }
};


